<template>
    <app-layout>
        <template #header></template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto px-1 sm:px-6 lg:px-8">
                <h1 class="text-2xl font-bold">
                    {{ this.asset.label }}
                </h1>

                <FormTextLabel
                    v-model="form.label"
                    id="title"
                    label="Title *"
                    subtitle="Add a title that describes this item."
                    placeholderText="Add a title"
                    containerClass="mb-6"
                    :error="errors.title ? errors.title[0] : ''"
                />

                <div class="mt-8 flex items-center space-x-4">
                    <DeleteAssetLink :asset="asset" />

                    <button type="button" class="underline" @click="cancel()">
                        Cancel
                    </button>

                    <button
                        class="
                            bg-blue-500
                            hover:bg-blue-700
                            text-white
                            font-bold
                            py-2
                            px-4
                        "
                        @click="save()"
                    >
                        Save
                    </button>
                    <div class="text-green-700" v-if="saveSuccessMessage">
                        {{ saveSuccessMessage }}
                    </div>
                    <div class="text-red-400" v-if="saveErrorMessage">
                        {{ saveErrorMessage }}
                    </div>
                    <div class="text-gray-400" v-if="isLoading">
                        Submitting...
                    </div>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import Multiselect from "@vueform/multiselect";
import flatPickr from "vue-flatpickr-component";
import FormTextLabel from "@/components/FormTextLabel";
import FormTextAreaLabel from "@/components/FormTextAreaLabel";
import FormSelect from "@/components/FormSelect";
import FormRadio from "@/components/FormRadio";
import FormDatepicker from "@/components/FormDatepicker";
import DeleteAssetLink from "@/Pages/Guidelines/DeleteAssetLink";
import "flatpickr/dist/flatpickr.css";

export default {
    props: ["asset"],
    components: {
        AppLayout,
        Multiselect,
        flatPickr,
        FormTextLabel,
        FormTextAreaLabel,
        FormSelect,
        FormRadio,
        FormDatepicker,
        DeleteAssetLink,
    },
    data() {
        return {
            form: {},
            previewImageUrl: "",
            categoriesMessage: "",
            saveSuccessMessage: "",
            saveErrorMessage: "",
            isLoading: false,
            errors: {},
            currentPageType: ""
        };
    },
    watch: {},
    methods: {
        async save() {
            this.isLoading = true;
            this.form.type = this.currentPageType;
            axios.put(`/api/brand-guideline-assets/${this.asset.id}`, this.form)
                .then((response) => {
                    window.location.href ="/guidelines";
                })
                .catch((error) => {
                    this.savedError();
                    if (error.response) {
                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors;
                        }
                    } else if (error.request) {
                        // console.log(error.request);
                    } else {
                        // console.log("Error", error.message);
                    }
                });

            this.isLoading = false;
        },
        savedSuccess() {
            this.saveSuccessMessage = "Saved!";
            setTimeout(() => {
                this.saveSuccessMessage = "";
            }, 3000);
        },
        savedError() {
            this.saveErrorMessage = "Error! Please check the form for errors.";
            setTimeout(() => {
                this.saveErrorMessage = "";
            }, 3000);
        },
        cancel() {
            window.location.href ="/guidelines";
        },
    },
    mounted() {

        this.form.type = this.asset.type;
        this.form.label = this.asset.label;
        this.currentPageType = window.location.pathname.split("/")[1];
    },
};
</script>

<style src="@vueform/multiselect/themes/default.css"></style>

<style scoped>
.multiselect-gray {
    --ms-tag-bg: #ccc;
    --ms-tag-color: #000;
    --ms-tag-radius: 0;
}
</style>
